export const GateMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M10 41V22C10 14.5 16.3 8.5 24 8.5C31.7 8.5 38 14.5 38 22V41" stroke="#DCBC7F" strokeWidth="2" />
    <path d="M16.5 41V24C16.5 19.6 19.9 16 24 16C28.1 16 31.5 19.6 31.5 24V41" stroke="#DCBC7F" strokeWidth="1.1" />
    <line x1="24" y1="16" x2="24" y2="41" stroke="#DCBC7F" strokeWidth="1.1" />
    <line x1="5" y1="41" x2="43" y2="41" stroke="#DCBC7F" strokeWidth="1.1" />
    <circle cx="24" cy="27.5" r="1.6" fill="#DCBC7F" />
  </svg>
);

export const LogoLockup = ({ compact = false }) => (
  <span className="flex items-center" data-testid="nav-logo">
    <img
      src="/logo-full.png"
      alt="The Gate Stays"
      className={`w-auto ${compact ? 'h-10' : 'h-14'}`}
    />
  </span>
);
